import React, { useState, useContext } from "react";

import { Context } from "@/contexts/AuthContext";
import { api } from "@/services/api";

import { Header } from "./styles";

export default function BarHeader() {
	const [logOut, setLogOut] = useState(false);
	const { handleLogout } = useContext(Context);
	const type = localStorage.getItem("@type");

	// logOut
	function handleLogoutUser() {
		setLogOut(true);

		api.get(`${type}/signout`, {
			params: { logout: true },
		})
			.then((res) => {
				// console.log(res);
			})
			.catch((error) => {
				console.warn({ endPoint: `${type}/signout`, error });
			})
			.finally(() => {
				setLogOut(false);
				handleLogout(`${process.env.PUBLIC_URL}`);
			});
	}

	return (
		<Header>			
			<img
				className="logo"
				src={require("../../assets/img/Logo@2x.png").default}
				alt='logo'
				loading='lazy'
			/>
			
			<h1>Programa Fidelidade Gerioox</h1>
			<button
				disabled={logOut ? "disabled" : ""}
				className='d-none d-lg-block logout'
				onClick={handleLogoutUser}>
				{logOut ? "Saindo..." : "Sair"}
			</button>
		</Header>
	);
}
